// extracted by mini-css-extract-plugin
module.exports = {"mainBar":"styles_mainBar__3tXf3","internalTopBar":"styles_internalTopBar__3Kad9","internalBottomBar":"styles_internalBottomBar__3DXps"};